import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { pricingStudioUrl } from '@/environment';
import map from '@/images/Map.svg';
import { useAuth } from '@/services/auth';
import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

const StyledButton = styled(ButtonBase)`
    display: flex;
    padding: 6px 8px;
    gap: 6px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    height: 34px;

    color: ${({ theme }) => theme.colors.secondary.main};
    border: 1px solid ${({ theme }) => theme.colors.black[300]};

    :hover {
        background-color: ${({ theme }) => theme.colors.black[50]};
    }
`;

export const ViewPlansButton = () => {
    const { isAnonymous } = useAuth();

    if (!isAnonymous) {
        return null;
    }

    const handleClick = () => {
        window.open(pricingStudioUrl, '_blank');
    };

    return (
        <StyledButton id="view-plans" onClick={handleClick}>
            <MaskedIcon src={map} size="16px" />
            View plans
        </StyledButton>
    );
};
